<template>
<div class="min-body">
  <!-- banner -->
  <banner :banner-list="bannerList" ></banner>
  <!-- 核心产品 -->
  <SectionTitle :title="$t('sectionTitle.coreProducts')" :subtitle="$t('sectionTitle.coreProductsSub')" style="margin:100px 0 50px 0;" />
  <ProductGrid></ProductGrid>
  <!-- 解决方案 -->
  <SectionTitle :title="$t('sectionTitle.solutions')" :subtitle="$t('sectionTitle.solutionsSub')" style="margin:100px 0 50px 0;" />
  <SolutionCard></SolutionCard>
  <!-- 核心能力 -->
  <SectionTitle :title="$t('sectionTitle.coreAbility')" :subtitle="$t('sectionTitle.coreAbilitySub')" style="margin:100px 0 50px 0;" />
  <CoreAbility></CoreAbility>
  <!-- 行业模型 -->
  <SectionTitle :title="$t('sectionTitle.industryModel')" subtitle="" style="margin:100px 0 30px 0;" />
  <IndustryModel></IndustryModel>
  <!-- 客户案例 -->
  <SectionTitle :title="$t('sectionTitle.customerCase')" subtitle="" style="margin:100px 0 30px 0;" />
  <CustomerCase :caseList="CustomerCaseList"></CustomerCase>



  <!-- Footer -->
  <Footer></Footer>
  <!-- END! -->
</div>
</template>

<script>
import Footer from '@/components/Footer'
import banner from './components/Banner/banner.vue'
import SectionTitle from '@/components/SectionTitle/index.vue';
import ProductGrid from "./components/ProductGrid/index.vue";
import SolutionCard from "./components/SolutionCard/index.vue";
import CoreAbility from "./components/CoreAbility/index.vue";
import CustomerCase from "./components/CustomerCase/index.vue";
import IndustryModel from "@/views/Home/components/IndustryModel/index.vue";
export default {
  name: "index",
  components: {
    Footer,
    banner,
    SectionTitle,
    ProductGrid,
    SolutionCard,
    CoreAbility,
    CustomerCase,
    IndustryModel
  },
  data(){
    return {
      startVal: 0,
      endVal: 1021,
      startVal1: 0,
      endVal1: 3109,
      startVal2: 0,
      endVal2: 103,
      startVal3: 0,
      endVal3: 200574,
      startVal4: 0,
      endVal4: 218190,
      bannerList: [
        {
          titleKey: 'home.banner.aiEngine.title',
          descKey: 'home.banner.aiEngine.desc',
          btnText: '',
          image: require('@/assets/img/Home/banner/banner06.webp'),
          link: '/about',
          bottomTextsKey: 'home.banner.aiEngine.tags'
        },
        {
          titleKey: 'home.banner.energySolution.title',
          descKey: 'home.banner.energySolution.desc',
          btnText: '',
          image: require('@/assets/img/Home/banner/banner04.webp'),
          link: '/about',
          bottomTextsKey: 'home.banner.energySolution.tags'
        },
        {
          titleKey: 'home.banner.digitalHuman.title',
          descKey: 'home.banner.digitalHuman.desc',
          btnText: '',
          image: require('@/assets/img/Home/banner/banner01.webp'),
          link: '/about',
          bottomTextsKey: 'home.banner.digitalHuman.tags'
        },
        {
          titleKey: 'home.banner.edgeDevice.title',
          descKey: 'home.banner.edgeDevice.desc',
          btnText: '',
          image: require('@/assets/img/Home/banner/banner02.webp'),
          link: '/about',
          bottomTextsKey: 'home.banner.edgeDevice.tags'
        },
        {
          titleKey: 'home.banner.drone.title',
          descKey: 'home.banner.drone.desc',
          btnText: '',
          image: require('@/assets/img/Home/banner/banner03.webp'),
          link: '/about',
          bottomTextsKey: 'home.banner.drone.tags'
        }
      ],

      CustomerCaseList: [
        {
          titleKey: 'home.cases.mineAiEye.title',
          descKey: 'home.cases.mineAiEye.desc',
          effectKey: 'home.cases.mineAiEye.effect',
          evaluationKey: 'home.cases.mineAiEye.evaluation',
          image: require("@/assets/img/Home/case/case01.jpg")
        },
        {
          titleKey: 'home.cases.intelligentDispatch.title',
          descKey: 'home.cases.intelligentDispatch.desc',
          effectKey: 'home.cases.intelligentDispatch.effect',
          evaluationKey: 'home.cases.intelligentDispatch.evaluation',
          image: require("@/assets/img/Home/case/case01.jpg")
        },
        {
          titleKey: 'home.cases.predictiveMaintenance.title',
          descKey: 'home.cases.predictiveMaintenance.desc',
          effectKey: 'home.cases.predictiveMaintenance.effect',
          evaluationKey: 'home.cases.predictiveMaintenance.evaluation',
          image: require("@/assets/img/Products/case/产品中心-AI设备专家平台-case.png")
        },
        {
          titleKey: 'home.cases.safetyAssistant.title',
          descKey: 'home.cases.safetyAssistant.desc',
          effectKey: 'home.cases.safetyAssistant.effect',
          evaluationKey: 'home.cases.safetyAssistant.evaluation',
          image: require("@/assets/img/Products/case/产品中心-问煤-case.png")
        },
        {
          titleKey: 'home.cases.edgeResponse.title',
          descKey: 'home.cases.edgeResponse.desc',
          effectKey: 'home.cases.edgeResponse.effect',
          evaluationKey: 'home.cases.edgeResponse.evaluation',
          image: require("@/assets/img/Products/case/产品中心-井下智能防爆终端-case.png")
        },
        {
          titleKey: 'home.cases.unmannedInstallation.title',
          descKey: 'home.cases.unmannedInstallation.desc',
          effectKey: 'home.cases.unmannedInstallation.effect',
          evaluationKey: 'home.cases.unmannedInstallation.evaluation',
          image: require('@/assets/img/Products/产品中心-液压支架辅助安装机器人-降本增效提安.png'),
        },
        {
          titleKey: 'home.cases.officeAutomation.title',
          descKey: 'home.cases.officeAutomation.desc',
          effectKey: 'home.cases.officeAutomation.effect',
          evaluationKey: 'home.cases.officeAutomation.evaluation',
          image: require("@/assets/img/Products/case/产品中心-Coalclaw私有化智能助手-case.png")
        },
        {
          titleKey: 'home.cases.antiViolationUpgrade.title',
          descKey: 'home.cases.antiViolationUpgrade.desc',
          effectKey: 'home.cases.antiViolationUpgrade.effect',
          evaluationKey: 'home.cases.antiViolationUpgrade.evaluation',
          image: require("@/assets/img/Algorithm/case/解决方案-反三违-case.png")
        },
        {
          titleKey: 'home.cases.fullScene.title',
          descKey: 'home.cases.fullScene.desc',
          effectKey: 'home.cases.fullScene.effect',
          evaluationKey: 'home.cases.fullScene.evaluation',
          image: require("@/assets/img/Algorithm/case/矿山全场景AI视频识别-case.png")
        },
        {
          titleKey: 'home.cases.chemicalPark.title',
          descKey: 'home.cases.chemicalPark.desc',
          effectKey: 'home.cases.chemicalPark.effect',
          evaluationKey: 'home.cases.chemicalPark.evaluation',
          image: require("@/assets/img/Algorithm/case/解决方案-化工解决方案-case.png")
        }
      ]
    }
  },
  mounted() {
    window.scrollTo(0,0);
  }
}
</script>

<style scoped lang="less">


</style>